import { formatPrice } from "@/lib/format";

export const Price = ({ item, s, lang, testid, large = false }) => {
  const f = (v) => formatPrice(v, lang, s.locale.currency, s.locale.arabic_digits);
  const promo = item.promotional_price != null ? item.promotional_price : null;
  const current = promo ?? item.price;
  const struck = promo != null ? item.price : item.original_price != null && item.original_price > item.price ? item.original_price : null;
  return (
    <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5" data-testid={testid}>
      <bdi className={`${large ? "text-2xl sm:text-3xl" : "text-lg"} font-extrabold tabular-nums`} style={{ color: "var(--wt-price)" }} data-testid={`${testid}-current`}>
        {f(current)}
      </bdi>
      {struck != null && (
        <bdi className="text-sm tabular-nums text-[var(--wt-muted)] line-through" data-testid={`${testid}-was`}>
          {f(struck)}
        </bdi>
      )}
    </div>
  );
};
